import React from "react";
import { Helmet } from "react-helmet";

function SSoft_Solution_XM_Seo() {
  return (
    <Helmet>
      <title>
        Infor XM Indonesia | Expense Management Solution by PT Supersoft
        Sistemindo
      </title>
      <meta
        name="description"
        content="Infor XM adalah solusi Expense Management untuk mengotomatisasi klaim perjalanan dinas dan pengeluaran perusahaan. PT Supersoft Sistemindo menyediakan lisensi dan implementasi resmi di Indonesia."
      />
      <meta
        name="keywords"
        content="Infor XM Indonesia, Expense Management software, travel expense automation, reimbursement system Indonesia, PT Supersoft Sistemindo"
      />
      <link
        rel="canonical"
        href="https://ptsupersoft.com/solutions/expense-management"
      />

      {/* ==== Open Graph ==== */}
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://ptsupersoft.com/solutions/expense-management"
      />
      <meta
        property="og:title"
        content="Infor XM Indonesia | Expense Management Solution"
      />
      <meta
        property="og:description"
        content="Automatisasi pengelolaan pengeluaran dengan Infor XM. PT Supersoft Sistemindo menyediakan lisensi dan implementasi untuk perusahaan di Indonesia."
      />
      <meta
        property="og:image"
        content="https://bzpublishassets.blob.core.windows.net/media/assets_small/hexagon.webp"
      />

      {/* ==== AI Search Optimization ==== */}
      <meta
        name="ai-keywords"
        content="Infor XM Indonesia, expense management system, corporate travel software, reimbursement automation, PT Supersoft Sistemindo"
      />
      <meta
        name="ai-summary"
        content="Infor XM menyederhanakan proses reimbursement dan perjalanan dinas melalui otomatisasi dan kontrol kebijakan. Partner resmi: PT Supersoft Sistemindo."
      />

      {/* ==== FAQ Schema ==== */}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Apa itu Infor XM?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Infor XM (Expense Management) adalah software untuk mengelola klaim perjalanan dan pengeluaran bisnis secara otomatis. Supersoft adalah partner resmi implementasi di Indonesia."
            }
          },
          {
            "@type": "Question",
            "name": "What is Infor XM?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Infor XM helps automate travel and expense management, reducing manual work and ensuring policy compliance. PT Supersoft Sistemindo provides licensing and implementation."
            }
          },
          {
            "@type": "Question",
            "name": "Apa manfaat utama Infor XM?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Menghemat waktu dalam pengajuan klaim, meningkatkan transparansi biaya, dan mengurangi risiko kecurangan melalui audit otomatis."
            }
          }
        ]
      }
      `}</script>
    </Helmet>
  );
}

export default SSoft_Solution_XM_Seo;
